export function iconForPin(pin) {
  const icons = window.CollectionneurAssets.pinIcons

  if (pin.pin_type === 'accommodation' || pin.pin_type === 'restaurant') {
    return icons.house
  }

  if (pin.starred) return icons.star
  if (pin.visited && pin.to_visit_again) return icons.return_to
  if (pin.visited) return icons.check

  return icons.plus
}

export function leafletIconForPin(pin) {
  return {
    iconUrl: iconForPin(pin),
    iconSize: [32, 37],
    iconAnchor: [16, 37],
    popupAnchor: [0, -37],
  }
}
